<template>
  <div class="space white-bg">
      <LayoutHeader />
      <LayoutSidebar/>
      <LayoutMain>
        <Permission v-if="!token"/>
        <Template v-else />
      </LayoutMain>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed} from 'vue'
import LayoutHeader from '../components/layout/Header.vue'
import LayoutSidebar from '../components/layout/Sidebar.vue'
import LayoutMain from '../components/layout/Main.vue'
import Template from '../Space/template.vue'
import Permission from '../Login/permission.vue'
import { useStore } from '@/store'
export default defineComponent({
  name: 'Space',
  components: {
    LayoutHeader, LayoutSidebar, LayoutMain, Template, Permission
  },
  setup() {
    const store = useStore()
    const token = computed(() => store.state.token)
    return {
      token
    }
  },
})
</script>

<style lang="scss">
.space {
  height: 100%;
}
</style>